import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment as env } from 'src/environments/environment';

export interface Keyword {
  id: number;
  text: string;
  active: boolean;
  createdAt: string;
}

@Injectable({
  providedIn: 'root'
})


export class KeywordsService {

    private apiKey =`${env.apiKey}`;
    private baseUrl = `${env.apiCerberoUrl}`;
    private keywordsUrl = `${env.keywordsUrl}`;

  constructor(private httpClient: HttpClient) {}

  uploadKeywordsS3(keywords: any[]): Observable<any> {
    const json = JSON.stringify(keywords, null, 2);

    const file = new File(
      [json],
      'keywords.json',
      { type: 'application/json' }
    );

    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('app', this.apiKey);
    formData.append('nameChange', 'NoChange');

    return this.httpClient.post<any>(
      `${this.baseUrl}/upload-file`,
      formData
    );
  }

  async getKeywords(): Promise<Keyword[]> {
    let keywords: Keyword[] = [];
    try {
      
      const response = await fetch(this.keywordsUrl, { cache: 'no-store' });

      if (!response.ok) {
        if (response.status === 404) {
          keywords = [];
          return keywords;
        }

        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data: Keyword[] = await response.json();
      keywords = Array.isArray(data) ? data : [];

    } catch (error) {
      console.error('Error cargando keywords:', error);
      keywords = [];
    }

    return keywords;

  }


}